import { useCallback } from "react";

import type * as Type from "../type";

type Props = {
	serverData: Type.ServerData.ReservationListByCOutDateServerData | undefined;
};
type Result = {
	queryData: Type.QueryData.ReservationListQueryData;
};

export const useReservationListByCOutDateQueryData = () => {
	/**
	 * QueryData へ変換
	 */
	const onConvertQueryData = useCallback(
		({ serverData }: Props): Result => ({
			queryData: {
				reservationList: serverData?.reservationListByCOutDate.reservations ?? [],
			},
		}),
		[],
	);

	return {
		onConvertQueryData,
	};
};
